import React, { createContext, useContext, useMemo } from "react";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import {
  findUserHoldingsModule,
  isUserHoldingsSubscribed,
} from "../../platform_spaces/space/userHoldingsEntitlement";

type UserHoldingsEntitlementValue = {
  /** 空间是否配置了持仓复盘产品 */
  holdingsModule: MembershipProduct | null;
  /** 当前用户是否已订阅持仓复盘 */
  holdingsEntitled: boolean;
};

const UserHoldingsEntitlementContext = createContext<UserHoldingsEntitlementValue>({
  holdingsModule: null,
  holdingsEntitled: false,
});

export function UserHoldingsEntitlementProvider(props: {
  membershipProducts: MembershipProduct[];
  children: React.ReactNode;
}): JSX.Element {
  const { membershipProducts, children } = props;
  const value = useMemo(
    () => ({
      holdingsModule: findUserHoldingsModule(membershipProducts),
      holdingsEntitled: isUserHoldingsSubscribed(membershipProducts),
    }),
    [membershipProducts]
  );
  return (
    <UserHoldingsEntitlementContext.Provider value={value}>
      {children}
    </UserHoldingsEntitlementContext.Provider>
  );
}

export function useUserHoldingsEntitlement(): UserHoldingsEntitlementValue {
  return useContext(UserHoldingsEntitlementContext);
}
